import { render, staticRenderFns } from "./s-editor.vue?vue&type=template&id=188c158d&"
import script from "./s-editor.vue?vue&type=script&lang=js&"
export * from "./s-editor.vue?vue&type=script&lang=js&"
import style0 from "./s-editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports